<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <options-input-field
      v-bind="$props"
      @input="$emit('input', $event)"
      @find="$emit('find', $event)"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import OptionsFieldMixin from 'vue-forms/mixins/OptionsFieldMixin';

export default {
  mixins: [ FormFieldMixin, OptionsFieldMixin ],
};
</script>
